import { Container, Stack, Typography } from '@mui/material';
import React from 'react';

const NotFound = () => {
  return (
    <Container maxWidth='md'>
      <Stack direction='column' sx={{ height: '100vh' }} justifyContent='center'>
        <Typography textAlign='center' sx={{ fontWeight: 700 }}>
          404 | Not found
        </Typography>
      </Stack>
    </Container>
  );
};

export default NotFound;
